// extracted by css-extract-rspack-plugin
export default {"sortText":"voRpB2QgSGErmbtX"};